import { USER_ROLE_SCOPE } from '@constants';

export const isRoleScope = {
  admin: (role) => USER_ROLE_SCOPE[role] === USER_ROLE_SCOPE.ADMIN,
  owner: (role) => USER_ROLE_SCOPE[role] === USER_ROLE_SCOPE.OWNER,
};
